import React from 'react'

import {
  Box,
  Card,
  RadioButton,
  StatusLabel,
  WizardStepRenderParams,
} from '@factorialco/deprecated-design-system'
import { ContactFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import BankInfoForm from 'modules/finance/components/Contacts/BankInfoForm'
import { contactFullName } from 'modules/finance/lib/contactsUtils'
import InfoItem from 'modules/procurement/components/InfoItem'
import type { WizardData } from 'modules/procurement/components/purchaseOrders/UpdateOrderModal/types'

interface Props {
  selected?: boolean
  preferred?: boolean
  vendor: ContactFragment | undefined
  canManageVendors: boolean
}

const BankTransferOption: React.FC<
  Pick<WizardStepRenderParams<WizardData>, 'data' | 'onDataChanged'> & Props
> = ({ preferred, selected, data, vendor, onDataChanged, canManageVendors }) => {
  if (!vendor) {
    return null
  }

  const handleSelected = () => {
    onDataChanged({
      ...data,
      preferredPaymentMethod: 'banktransfer',
    })
  }

  return (
    <Card onClick={handleSelected}>
      {preferred && (
        <Card.Eyebrow>
          <StatusLabel type="info">
            {i18n.t(
              'procurement.purchase_orders.update_order_wizard.steps.payment_method.preferred_option'
            )}
          </StatusLabel>
        </Card.Eyebrow>
      )}
      <Card.Title
        action={
          <RadioButton
            value="bank-transfer"
            checked={!!selected}
            onChange={(event) => event.target.value === 'bank-transfer' && handleSelected()}
          />
        }
      >
        {i18n.t(
          'procurement.purchase_orders.update_order_wizard.steps.payment_method.options.bank_transfer.title'
        )}
      </Card.Title>
      <Card.Description>
        {i18n.t(
          'procurement.purchase_orders.update_order_wizard.steps.payment_method.options.bank_transfer.description'
        )}
      </Card.Description>
      <Card.ExpandableContent
        expanded={selected}
        onExpandChange={(expanded) => expanded && handleSelected()}
      >
        <Box gap="s16">
          <InfoItem
            label={i18n.t('procurement.purchase_orders.detail.vendor.title')}
            textItem={contactFullName(vendor)}
          />
          <BankInfoForm
            vendor={vendor}
            editable={canManageVendors}
            onSuccess={(bankCode, iban) =>
              onDataChanged({
                ...data,
                preferredPaymentMethod: 'banktransfer',
                bankPaymentDetails: {
                  bankCode,
                  iban,
                },
              })
            }
          />
        </Box>
      </Card.ExpandableContent>
    </Card>
  )
}

export default BankTransferOption
